import axiosConfig from "./axiosConfig";

// Service pour gérer les requêtes API
const DoctorService = {
  getAllDoctors: async () => {
    try {
      const response = await axiosConfig.get(`doctors`);
      return response.data;
    } catch (error) {
      console.error("Error fetching doctors:", error);
      throw error;
    }
  },

  createDoctor: async (doctorData) => {
    try {
      const formData = new FormData();
      formData.append("titre", doctorData.titre);
      formData.append("name", doctorData.name);
      formData.append("specialization", doctorData.specialization);
      formData.append("phone", doctorData.phone);
      formData.append("email", doctorData.email);

      if (doctorData.photo) {
        formData.append("photo", doctorData.photo);
      }

      const response = await axiosConfig.post(`doctors`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating doctor:", error);
      throw error;
    }
  },

  updateDoctor: async (id, doctorData) => {
    try {
      const formData = new FormData();
      formData.append("titre", doctorData.titre);
      formData.append("name", doctorData.name);
      formData.append("specialization", doctorData.specialization);
      formData.append("phone", doctorData.phone);
      formData.append("email", doctorData.email);

      if (doctorData.photo) {
        formData.append("photo", doctorData.photo);
      }

      const response = await axiosConfig.put(`doctors/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating doctor with id ${id}:`, error);
      throw error;
    }
  },

  deleteDoctor: async (id) => {
    try {
      const response = await axiosConfig.delete(`doctors/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting doctor with id ${id}:`, error);
      throw error;
    }
  },

  getDoctorById: async (id) => {
    try {
      const response = await axiosConfig.get(`doctors/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching doctor with id ${id}:`, error);
      throw error;
    }
  },
};

export default DoctorService;
